import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {ReturnDetailInfoDto} from "../models/return.models";

@Injectable({
  providedIn: 'root'
})
export class ReturnDetailService {

  returnDetailService$: Subject<ReturnDetailInfoDto | null> = new BehaviorSubject<ReturnDetailInfoDto | null>(null)

}
